<script setup>
import RecruiterService from "@/services/RecruiterService"
import Step from "@/views/survey/Step.vue"
import Validator from "@/views/survey/Validator.vue"
import FooterBlank from "@/layouts/components/FooterBlank.vue"
import ContentError from "@/components/common/ContentError.vue"

import { useSurveyHandle } from "@/composables/useSurvey"
import { useAuthStore } from "@/stores/authStore"
import { useRoute } from "vue-router"
import { router } from "@/plugins/1.router"
// ==================== START VARIABLE ======================
const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR
const BASE_URL = import.meta.env.VITE_API_BASE_URL
const route = useRoute()
const { params } = useRoute()
const textValider = ref(null)
const {
  currentTab,
  dataLoaded,
  dataSurvey,
  extraTabs,
  isShow,
  computedSteps,
  isCheckAllStepSuccess,
  failureSteps,
  errorData,
  loading,
  buttonLoading,

  isDev,
  goFinalStep,
  isStepDisabled,
  startSurveyWithParams,
} = useSurveyHandle("recruiter", RecruiterService, params.id)

definePage({
  meta: {
    layout: "blank",
    public: true,
  },
})
const infoBlocks = [
  {
    id: 1,
    position: "bottom",
    type: "alert",
    content: `
      <p class="text-error text-justify">
          ${$gettext(
            "ATTENTION : une fois votre formulaire validé, il est envoyé directement à nos services et vous n’avez plus la possibilité de le rectifier."
          )}
      </p>
      <p class="text-error text-justify">
          ${$gettext(
            "Vous saurez que votre formulaire est bien validé quand vous recevrez par e-mail une confirmation de validation. Un PDF reprenant toutes vos réponses sera téléchargeable dans ce mail pour que vous puissiez relire et archiver vos réponses."
          )}
      </p>
      `,
  },
]

const campaign = ref(import.meta.env.VITE_CAMPAIGN == 1)
const isAdmin = computed(() => route.query.isAdmin)
const authStore = useAuthStore()

watch(
  () => campaign.value,
  async (newVal) => {
    if (!newVal) {
      if (isAdmin.value != 1 || !isAdmin.value) {
        await authStore.logout()
      }
    }
  },
  { immediate: true }
)
// ==================== START METHODS ======================

async function getPdfCompany(id) {
  const url = RecruiterService.exportFile(BASE_URL, id)
  window.open(url, "_blank")
}

async function onSubmit(obj) {
  try {
    buttonLoading.value = true
    obj.hash = params.id
    obj.totalStep = computedSteps.value.length
    const response = await RecruiterService.postSurveyByStep({
      ...obj,
    })

    if (response) {
      if (textValider.value) {
        console.log("textValider", textValider.value)
        location.reload()
      }
      await startSurveyWithParams()
      if (dataSurvey.value?.currentStep)
        currentTab.value = dataSurvey.value?.currentStep
      goFinalStep(currentTab.value)

      setTimeout(() => {
        window.scrollTo({ top: 50, behavior: "smooth" })
      }, 350)
    }
  } catch (error) {
    errorData.value = error?.data
  } finally {
    buttonLoading.value = false
  }
}
// ==================== END METHODS ========================
// onMounted(async () => {
//   router.push("/")
//   return
// })
watch(
  () => dataSurvey.value,
  (newVal) => {
    if (newVal) {
      currentTab.value = !isCheckAllStepSuccess.value
        ? -1
        : computedSteps.value.length
    }
    console.log("currentTab", currentTab.value)
  },
  { immediate: true }
)
</script>

<template>
  <div class="register-student">
    <div
      class="register-student__container"
      style="width: 1320px; max-width: 100%; margin: auto; padding: 20px"
    >
      <div class="register-student__bg">
        <img src="@/assets/images/palm_bg.svg" alt="palm" style="top: 0" />
      </div>
      <!-- Start Header -->
      <header
        class="d-flex align-center justify-space-between register-student__container-header"
        style="position: relative"
      >
        <RouterLink to="/" class="app-logo app-title-wrapper">
          <img
            src="@/assets/logo-eduniversal.png"
            alt="Logo"
            style="max-width: 140px"
          />
        </RouterLink>
        <div></div>
        <!-- <BtnLang @onChange="onChangeLang" /> -->
      </header>
      <main
        style="background: #fff; max-width: 1280px; margin: auto"
        :class="[
          'register-student__main py-6 mt-4',
          errorData?.code ? 'd-flex align-center flex-column' : '',
        ]"
      >
        <VCard v-if="errorData?.code" style="max-width: 990px; margin: auto">
          <VCardText>
            <ContentError :code="errorData?.code" />
          </VCardText>
        </VCard>
        <template v-else>
          <div class="survey">
            <div class="survey__top">
              <h1 style="font-weight: 700">
                {{ dataSurvey.formType?.name }}
              </h1>
              <h2 style="padding: 10px 0; margin: 0; font-weight: 600">
                {{ dataSurvey.program?.name }}
              </h2>
            </div>

            <div class="survey__main mt-3">
              <div class="d-flex gap-6 flex-row-reverse me-5 survey__company">
                <VTabs
                  v-model="currentTab"
                  class="v-tabs-pill primary-tab"
                  direction="vertical"
                >
                  <VTab
                    v-for="(item, index) in computedSteps"
                    :key="item.id"
                    :value="index"
                    :disabled="isStepDisabled(item)"
                  >
                    <VIcon
                      start
                      :icon="item.isCompleted ? 'tabler-check' : 'tabler-x'"
                      size="24"
                      :color="
                        currentTab === index
                          ? 'white'
                          : item.isCompleted
                          ? 'success'
                          : 'error'
                      "
                      style="margin-right: 35px"
                    />
                    <span>
                      {{ isDev() ? item.id + " " : "" }}{{ item.name }}
                    </span>
                  </VTab>

                  <VBtn
                    v-if="!dataLoaded"
                    @click="getPdfCompany(dataSurvey?.id)"
                    color="#4361ee"
                    class="extra-tab print-pdf"
                    style="
                      padding: 12px 16px;
                      max-width: 168px;
                      height: fit-content;
                    "
                  >
                    <VIcon
                      start
                      icon="tabler-printer"
                      size="24"
                      color="white"
                    />
                    <p>
                      {{
                        $gettext(
                          "Imprimer une version de mon formulaire en PDF"
                        )
                      }}
                    </p>
                  </VBtn>

                  <div v-if="dataLoaded" style="display: none">
                    <VTab
                      v-for="(tab, index) in extraTabs"
                      :key="tab.id"
                      :value="computedSteps?.length + index"
                      class="extra-tab d-none"
                      :style="[
                        tab.color === 'info'
                          ? 'background: #4361ee'
                          : 'background: rgba(var(--v-theme-success))',
                      ]"
                    >
                      <VIcon start :icon="tab.icon" size="24" color="white" />
                      <p>{{ tab.name }}</p>
                    </VTab>
                  </div>
                </VTabs>

                <VCard
                  class="flex-1 px-6 py-6 me-6 border-recruiter-question"
                  style="border: none"
                >
                  <Waiting :show="loading" :isBlurFullScreen="false" />
                  <VCardText>
                    <VWindow v-model="currentTab">
                      <VWindowItem
                        value="-1"
                        :class="[currentTab === -1 ? 'd-block' : 'd-none']"
                      >
                        <div>
                          <DefaultStepMM
                            :data="infoBlocks"
                            v-model:currentTab="currentTab"
                          />
                        </div>
                      </VWindowItem>
                      <VWindowItem
                        v-for="(item, index) in computedSteps"
                        :key="item.id"
                        :value="index"
                        class="form-survey"
                        transition="fade-transition"
                        reverse-transition="fade-transition"
                      >
                        <h4 class="form-survey__title">
                          {{ item.title }}
                        </h4>
                        <!-- <pre>{{ item }}</pre> -->
                        <hr class="space" />

                        <!-- question -->
                        <Step
                          :step="item"
                          :loading="buttonLoading"
                          :survey="dataSurvey"
                          :currentTab="currentTab"
                          :totalSteps="computedSteps?.length"
                          :isRecruiter="true"
                          @update:modelValue="onSubmit($event)"
                          @update:goBackStep="goFinalStep($event)"
                          @update:update:showPopup="isShow"
                          v-model:textValider="textValider"
                        />
                      </VWindowItem>

                      <div v-if="dataLoaded">
                        <VWindowItem
                          v-for="(tab, index) in extraTabs"
                          :key="tab.id"
                          :value="computedSteps?.length + index"
                        >
                          <h4 class="form-survey__title">{{ tab.title }}</h4>
                          <hr class="space" />
                          <Validator
                            :disabled="dataSurvey?.isValidated"
                            :items="computedSteps"
                            :isCheckAllStepSuccess="isCheckAllStepSuccess"
                            :failureSteps="failureSteps"
                            :idSurvey="dataSurvey.id"
                            :isRecruiter="true"
                            @update:currentTab="goFinalStep($event)"
                          />
                        </VWindowItem>
                      </div>
                    </VWindow>
                  </VCardText>
                </VCard>
              </div>
            </div>
          </div>
        </template>
      </main>
    </div>
    <VCard class="register-student__contact">
      <ContactWithUs />
    </VCard>
    <FooterBlank :footerRh="true" />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/pages/register-student.scss";
@import "@/assets/styles/pages/survey.scss";
.register-student__header {
  gap: 10px;
}
.border-recruiter-question {
  border: none !important;
  padding: 0 !important;
}
.print-pdf {
  padding: 12px 16px;
  max-width: 168px;
  height: fit-content;
}
.v-window-item[value="-1"].v-window-item--active {
  display: flex !important;
  flex-direction: column;
  background: yellow;
}
</style>
